
import t from "../../../../service/translate.service";
import { Modal } from "antd";

const TimeExceededModal = (props) => {

  return (
    <Modal
      open={true}
      onCancel={() => props.onTimeExceeded()}
      footer={[
        <button
          className="button primary small"
          key="ok"
          onClick={() => props.onTimeExceeded()}
          aria-label={t.CONFIRM_TIME_EXCEEDED}
        >
          {t.CONSULTATIONS_OK}
        </button>
      ]}
      aria-labelledby="timeExceededModalTitle"
      role="dialog"
      aria-live="assertive"
    >
      <div className="modal-body-wrapper">
        <p className="modal-p" id="timeExceededModalTitle" aria-live="assertive" role='alert'>
          {t.CONSULTATIONS_EXCEEDED_BOOKING_TIME}
        </p>
      </div>
    </Modal>
  );
};

export default TimeExceededModal;
